/**
 * Whether this questionnaire deployment shows chat, and where it calls.
 *
 * Chat is off unless a deployment turns it on, so a partner build that has not
 * been configured for chat loads no widget and makes no request. The API path is
 * same-origin on purpose: the browser calls this site, and the site's server
 * forwards to chat-service, so no session cookie leaves this origin and
 * chat-service is not a second browser endpoint.
 */

export interface ChatConfig {
  enabled: boolean;
  apiBasePath: string;
  contact: { label: string; url: string };
}

const DEFAULT_API_BASE_PATH = '/api/chat';
const DEFAULT_CONTACT = {
  label: 'email an advocate',
  url: 'mailto:advocate@resolvemedicalbills.com',
};

export function readChatConfig(env: ImportMetaEnv = import.meta.env): ChatConfig {
  return {
    enabled: env.VITE_CHAT_ENABLED === 'true',
    apiBasePath: env.VITE_CHAT_API_BASE_PATH || DEFAULT_API_BASE_PATH,
    contact: {
      label: env.VITE_CHAT_CONTACT_LABEL || DEFAULT_CONTACT.label,
      url: env.VITE_CHAT_CONTACT_URL || DEFAULT_CONTACT.url,
    },
  };
}
